import React from "react";
import Farm from "../../../certificates/Farm.png";
const TrackingOfProgress = ({ image, quotationType }) => {
  return (
    <div style={{ pageBreakInside: "avoid" }}>
      <h3 style={{ marginTop: "40px" }} className="table-heading">
        Tracking of Progress
      </h3>
      <p className="fs-3 mb-0">Specifications :</p>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "30%" }}>Item</th>
            <th>Description / Specification</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>01.</td>
            <td> alpha.kryzen.com</td>
            <td>
              Once KBPL receives work order from you. Your client portal access
              is created by us. At client portal you get access to timeline of
              development, team working on your project,{" "}
              {quotationType !== "fanpad" &&
                quotationType !== "nvph" &&
                quotationType !== "nethouse" &&
                `site inspection
              details, information of agronomist,`}{" "}
              delivery of goods, track of progress, etc.
            </td>
          </tr>
        </tbody>
      </table>
      {image != "visible" ? (
        <div
          style={{
            display: "flex",

            justifyContent: "center",
            width: "100%",
            marginTop: "12px",
          }}
        >
          <img
            src={
              "https://res.cloudinary.com/dsmabnook/image/upload/v1749639013/hm2_y4twz3_phxi61.png"
            }
            width={"100%"}
            alt="kryzenCertificates"
          />
        </div>
      ) : (
        ""
      )}
      {image != "visible" ? (
        <div
          style={{
            display: "flex",

            justifyContent: "center",
            width: "100%",
            marginTop: "12px",
          }}
        >
          <img src={Farm} width={"100%"} alt="kryzenCertificates" />
        </div>
      ) : (
        ""
      )}
      {/* <div
        style={{
          position: "relative",
          bottom: "10px",
          right: "10px",
          fontSize: "14px",
          textAlign: "right",
        }}
      >
        3/38
      </div> */}
    </div>
  );
};

export default TrackingOfProgress;
